import getPageType, { PageType, PageTypeOptions } from '@spa/lib/tracking/getPageType';
import pushToDataLayer, {
  SearchEventMetadata,
  TrackingEvent,
  TrackingSearchEvent
} from './pushToDataLayer';

const trackSearchActions = (
  searchTerm: string,
  searchResults: number,
  pageTypeOptions: PageTypeOptions,
  searchMetadata: SearchEventMetadata
): void => {
  const pageType: PageType = getPageType(pageTypeOptions);

  const searchEvent: TrackingSearchEvent = {
    event: TrackingEvent.SEARCH,
    search_results: searchResults,
    search_term: searchTerm,
    page_type: pageType,
    searchMetadata
  };

  pushToDataLayer(searchEvent);
};

export default trackSearchActions;
